import { render, staticRenderFns } from "./pulmonaryEmbolism.vue?vue&type=template&id=cd5c1902&scoped=true&"
import script from "./pulmonaryEmbolism.vue?vue&type=script&lang=js&"
export * from "./pulmonaryEmbolism.vue?vue&type=script&lang=js&"
import style0 from "./pulmonaryEmbolism.vue?vue&type=style&index=0&id=cd5c1902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5c1902",
  null
  
)

export default component.exports